import dataSources from 'dataSources';
import { batch } from 'react-redux';
import{ STATUS_LOADING } from 'common/constants';
import { TOperation } from 'common/types/store/operation';
import { getResponseError } from 'common/utils/index';

import slice from '../reducer/slice';
import { applicationActions } from 'entities/application';

const { setSettings, setSettingsStatusLoading } = slice.actions;
const { setErrorNotice } = applicationActions;

const operation: TOperation = () => async (dispatch: any) => {
  try {
    dispatch(setSettingsStatusLoading(STATUS_LOADING.load));

    const settings = await dataSources.user.getSettings();

    batch(() => {
      dispatch(setSettingsStatusLoading(STATUS_LOADING.done));
      dispatch(setSettings(settings));
    });
  } catch (e) {
    const error = await getResponseError(e);
    dispatch(setErrorNotice(error));
    dispatch(setSettingsStatusLoading(STATUS_LOADING.error));
  }
};

export default operation;
